/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Sports_PhysioInputs */

const en_service_type_sports_physio = /** @type {(inputs: Service_Type_Sports_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports physiotherapy`)
};

const pl_service_type_sports_physio = /** @type {(inputs: Service_Type_Sports_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapia sportowa`)
};

/**
* | output |
* | --- |
* | "Sports physiotherapy" |
*
* @param {Service_Type_Sports_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_sports_physio = /** @type {((inputs?: Service_Type_Sports_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Sports_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_sports_physio(inputs)
	return en_service_type_sports_physio(inputs)
});